import React, { useState } from 'react';

import ImagesGallery from 'Components/organisms/ImagesGallery';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function ImageGalleryComponent() {
  return (
    <div className={cx('image-gallery-container')}>
      <ImagesGallery
        Images={[
          {
            image:
              'https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/280px-Unofficial_JavaScript_logo_2.svg.png',
          },
          {
            image:
              'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png',
          },
          {
            image:
              'https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Sass_Logo_Color.svg/1200px-Sass_Logo_Color.svg.png',
          },
          { image: 'https://ko.mobx.js.org/img/mobx.png' },
        ]}
      />
    </div>
  );
}
export default ImageGalleryComponent;

export const path = '/image_gallery';
